import { render, staticRenderFns } from "./DonutChart20.vue?vue&type=template&id=f5b1c3fa&scoped=true&"
import script from "./DonutChart20.vue?vue&type=script&lang=js&"
export * from "./DonutChart20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b1c3fa",
  null
  
)

export default component.exports